import { zodResolver } from "@hookform/resolvers/zod";
import { useSignInEmailPassword } from "@nhost/react";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { z } from "zod";
import { cn } from '@/lib/utils'

import { Button, buttonVariants } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormMessage,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Separator } from "@/components/ui/separator";
import ForgotPassword from "../forgot-password";

const formSchema = z.object({
  email: z.string().email(),
  password: z.string().min(8),
});

export default function SignInEmailPassword() {
  const navigate = useNavigate();
  const { signInEmailPassword } = useSignInEmailPassword();
  const [showEmailVerificationDialog, setShowEmailVerificationDialog] =
    useState(false);

  const form = useForm<z.infer<typeof formSchema>>({
    resolver: zodResolver(formSchema),
    defaultValues: {
      email: "",
      password: "",
    },
  });

  const onSubmit = async (values: z.infer<typeof formSchema>) => {
    const { email, password } = values;
    const result = await signInEmailPassword(email, password);

    if (result.isError) {
      if (result.error?.message.includes("User is already signed in")) {
        navigate("/home", { replace: true });
      } else {
        toast.error(result.error?.message);
      }
    } else if (result.needsEmailVerification) {
      setShowEmailVerificationDialog(true);
    } else if (result.isSuccess) {
      navigate("/home", { replace: true });
    }
  };

  return (
    <div className="flex flex-row items-center justify-center w-screen min-h-screen bg-gray-100">
      <div className="flex flex-col items-center justify-center w-full max-w-md p-8 bg-white rounded-md shadow">
        <h1 className="mb-8 text-3xl text-center">Se connecter</h1>
        <Form {...form}>
          <form
            onSubmit={form.handleSubmit(onSubmit)}
            className="flex flex-col w-full space-y-4"
          >
            <FormField
              control={form.control}
              name="email"
              render={({ field }) => (
                <FormItem>
                  <FormControl>
                    <Input placeholder="E-Mail" type="email" {...field} />
                  </FormControl>
                  <FormMessage className="text-xs" />
                </FormItem>
              )}
            />

            <FormField
              control={form.control}
              name="password"
              render={({ field }) => (
                <FormItem>
                  <FormControl>
                    <Input
                      placeholder="Mot de passe"
                      type="password"
                      autoComplete="none"
                      {...field}
                    />
                  </FormControl>
                  <FormMessage className="text-xs" />
                </FormItem>
              )}
            />
            <Button type="submit">Se connecter</Button>
            
          </form>
        </Form>

        <Separator className="my-2" />
        <Link to={'/forgot-password'}
              className={cn(
                buttonVariants({ variant: 'link' }),
                'bg-[#999999DD] text-white hover:opacity-90 hover:no-underline'
              )} >
                Mot de passe oublié
            </Link>
      </div>
    
      <Dialog
        open={showEmailVerificationDialog}
        onOpenChange={(open) => setShowEmailVerificationDialog(open)}
      >
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Email de vérification envoyé</DialogTitle>
          </DialogHeader>
          <p>
            Vous devez d'abord vérifier votre email. Veuillez vérifier votre
            boîte mail et suivre le lien de confirmation pour compléter
            l'inscription.
            
          </p>
        </DialogContent>
      </Dialog>
    </div>
  );
}
